import { render, staticRenderFns } from "./appBarNotificationCenter.vue?vue&type=template&id=a2609d20"
import script from "./appBarNotificationCenter.vue?vue&type=script&lang=ts"
export * from "./appBarNotificationCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports